export enum ActionEnum {
  ACTION_EDIT = 'edit',
  ACTION_DELETE = 'delete',
  ACTION_CUSTOM = 'custom',
}
